import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/site";
import { useFeedback } from "@/components/Feedback";

const LINKS = [
  { label: "Collections", id: "collections" },
  { label: "Gold Rates", id: "rates" },
  { label: "Swarna Nidhi", id: "scheme" },
  { label: "Heritage", id: "heritage" },
  { label: "Visit Us", id: "contact" },
];

export const Navbar = ({ top = 36 }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { openEnquiry } = useFeedback();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <nav
      data-testid="main-navbar"
      style={{ top }}
      className={`fixed inset-x-0 z-[90] transition-all duration-500 ${
        scrolled ? "border-b border-[#D4AF37]/15 bg-[#060B18]/85 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 lg:px-8">
        <button data-testid="nav-logo-button" onClick={() => go("hero")} className="flex items-center gap-3">
          <img src="/assets/logo-badge.png" alt="Aradhana crest" className="h-9 w-9 rounded-lg" />
          <span className="hidden flex-col items-start sm:flex">
            <span className="font-serif text-lg leading-none tracking-wide text-[#F3E5AB]">ARADHANA</span>
            <span className="font-mono text-[8px] tracking-[0.45em] text-[#99732B]">JEWELLERS</span>
          </span>
        </button>
        <div className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="font-display text-[13px] tracking-wide text-[#B5B0A8] transition-colors duration-300 hover:text-[#E6C265]"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-enquire-button"
            onClick={() => openEnquiry("Priority Enquiry", "enquiry")}
            className="btn-gold !px-6 !py-2.5 !text-xs"
          >
            Enquire
          </button>
        </div>
        <button
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="rounded-full border border-white/10 p-2.5 text-[#E6C265] lg:hidden"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="overflow-hidden border-b border-[#D4AF37]/15 bg-[#060B18]/95 backdrop-blur-xl lg:hidden"
          >
            <div className="flex flex-col gap-1 px-6 py-4">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="py-3 text-left font-display text-sm text-[#B5B0A8] transition-colors hover:text-[#E6C265]"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="nav-mobile-enquire-button"
                onClick={() => {
                  setOpen(false);
                  openEnquiry("Priority Enquiry", "enquiry");
                }}
                className="btn-gold my-3 !py-3 !text-xs"
              >
                Enquire
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};
